{
  "name": "@rumtrace/web-sdk",
  "version": "0.5.0",
  "description": "Browser RUM SDK built on OpenTelemetry JS.",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/rumtracehq/web-sdk.git"
  },
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./react-router": {
      "types": "./dist/react-router.d.ts",
      "import": "./dist/react-router.js",
      "require": "./dist/react-router.cjs"
    },
    "./next-pages-router": {
      "types": "./dist/next-pages-router.d.ts",
      "import": "./dist/next-pages-router.js",
      "require": "./dist/next-pages-router.cjs"
    },
    "./next-app-router": {
      "types": "./dist/next-app-router.d.ts",
      "import": "./dist/next-app-router.js",
      "require": "./dist/next-app-router.cjs"
    }
  },
  "sideEffects": false,
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "scripts": {
    "build": "tsup src/index.ts src/react-router.ts src/next-pages-router.ts src/next-app-router.ts --format esm,cjs --dts --sourcemap --clean",
    "changeset": "changeset",
    "version-packages": "changeset version",
    "release": "npm run build && changeset publish",
    "test": "vitest run",
    "typecheck": "tsc --noEmit",
    "size": "size-limit"
  },
  "dependencies": {
    "@opentelemetry/api": "1.9.1",
    "@opentelemetry/instrumentation": "0.217.0",
    "@opentelemetry/instrumentation-document-load": "0.62.0",
    "@opentelemetry/instrumentation-fetch": "0.217.0",
    "@opentelemetry/instrumentation-xml-http-request": "0.217.0",
    "@opentelemetry/otlp-transformer": "0.218.0",
    "@opentelemetry/resources": "2.7.1",
    "@opentelemetry/sdk-logs": "0.217.0",
    "@opentelemetry/sdk-trace-base": "2.7.1",
    "@opentelemetry/sdk-trace-web": "2.7.1",
    "web-vitals": "5.2.0"
  },
  "peerDependencies": {
    "next": ">=13",
    "react": ">=18",
    "react-router": ">=6"
  },
  "peerDependenciesMeta": {
    "next": {
      "optional": true
    },
    "react": {
      "optional": true
    },
    "react-router": {
      "optional": true
    }
  },
  "devDependencies": {
    "@changesets/cli": "^2.31.0",
    "@size-limit/preset-small-lib": "12.1.0",
    "@types/node": "25.6.2",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "fake-indexeddb": "6.2.5",
    "fast-check": "4.7.0",
    "happy-dom": "20.9.0",
    "react": "19.2.6",
    "react-dom": "19.2.6",
    "react-router": "7.15.0",
    "size-limit": "12.1.0",
    "tsup": "8.5.1",
    "typescript": "6.0.3",
    "vitest": "4.1.5"
  }
}
